// extracted by mini-css-extract-plugin
module.exports = {"container":"panel_container__1hcLh","header":"panel_header__1m1Bi","footer":"panel_footer__1-Gyq"};